const NAME = "ONBOARDING_PROCESSES";

export default NAME;